import { animated, useSpring } from '@react-spring/web';
import { useReducedMotion } from 'animations/useReducedMotion';
import React, { FC } from 'react';

interface AnimatedListSkeletonProps {
    rows?: number;
    className?: string;
}

const SkeletonRow: FC<{ index: number }> = ({ index }) => {
    const reducedMotion = useReducedMotion();
    const spring = useSpring({
        from: { opacity: 0.35 },
        to: async (next) => {
            while (!reducedMotion) {
                await next({ opacity: 0.85 });
                await next({ opacity: 0.35 });
            }
        },
        config: { duration: 900 },
        delay: index * 80,
    });

    return (
        <animated.div
            style={spring}
            className="mb-2 h-10 w-full rounded-md bg-slate-100"
        />
    );
};

const AnimatedListSkeleton: FC<AnimatedListSkeletonProps> = ({ rows = 6, className = '' }) => {
    return (
        <div className={`py-4 ${className}`.trim()} aria-busy="true" aria-label="Loading">
            {Array.from({ length: rows }).map((_, i) => (
                <SkeletonRow key={i} index={i} />
            ))}
        </div>
    );
};

export default AnimatedListSkeleton;
